import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { GlobalOverview } from '../../components/GlobalOverview'
import { useAdminStats, useDesaList, useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/')({
  component: PlatformOverview,
})

function PlatformOverview() {
  const { data: session } = useSession()
  const user = session?.user
  const isAdmin = user?.role === 'platform_admin'
  const { data: stats, isLoading: loadingStats } = useAdminStats(isAdmin)
  const { data: desaList, isLoading: loadingDesa } = useDesaList()
  const logout = useLogout()

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <GlobalOverview
        stats={stats}
        desaList={desaList}
        isLoadingStats={loadingStats}
        isLoadingDesa={loadingDesa}
        isAdmin={isAdmin}
      />
    </AppShell>
  )
}
